import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import EngineeringPage from "@/pages/EngineeringPage";
import SpaSeriesPage from "@/pages/SpaSeriesPage";
import JacuzziSeriesPage from "@/pages/JacuzziSeriesPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CustomSolutionsPage from "@/pages/CustomSolutionsPage";
import ContactPage from "@/pages/ContactPage";
import DeveloperSpaPage from "@/pages/DeveloperSpaPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/engineering" element={<EngineeringPage />} />
              <Route path="/spa-series" element={<SpaSeriesPage />} />
              <Route path="/jacuzzi-series" element={<JacuzziSeriesPage />} />
              <Route path="/spa-series/:slug" element={<ProductDetailPage />} />
              <Route path="/jacuzzi-series/:slug" element={<ProductDetailPage />} />
              <Route path="/custom-solutions" element={<CustomSolutionsPage />} />
              <Route path="/custom-solutions/developer-services" element={<DeveloperSpaPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={
                <div data-testid="not-found-page" className="pt-40 pb-24 min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
                  <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 mb-4">404</h1>
                  <p className="text-slate-500 mb-8">This page could not be found.</p>
                  <a href="/" data-testid="not-found-home-link" className="bg-slate-800 text-white px-8 py-3 text-sm uppercase tracking-widest font-medium hover:bg-slate-700 transition-colors duration-300">Back to Home</a>
                </div>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
        <WhatsAppButton />
        <Toaster position="top-right" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
